export default __webpack_public_path__ + "static/media/red1.a52aee68.png";